import { graphql } from "@graphql-generated/gql";
import { MeGraphqlQuery } from "@graphql-generated/graphql";

export type QueriedRoles = MeGraphqlQuery["me"]["possedeRoles"];
export const MeGraphql = graphql(`
    query MeGraphql {
        me {
            id
            properties
            firstName
            lastName
            userName
            email
            client {
                id
                name
            }
            subTenant {
                id
            }
            possedeRoles {
                id
                name
                permissions
            }
        }
    }
`);
